import React from 'react';
import { SparkLogo } from './ui/SparkLogo';
export function Footer() {
  return <footer className="bg-[#FAFAFC] border-t border-[#E5E7EB] py-12" data-id="element-59">
      <div className="max-w-[1200px] mx-auto px-8 flex flex-col md:flex-row items-center md:items-center justify-between gap-8" data-id="element-60">
        {/* Left — Logo + tagline */}
        <div className="flex flex-col items-center md:items-start gap-1.5" data-id="element-61">
          <div className="flex items-center gap-2" data-id="element-62">
            <SparkLogo size={26} data-id="element-63" />
            <span className="font-bold text-lg tracking-tight text-gray-900" data-id="element-64">
              Spark<span className="text-gradient" data-id="element-65">HR</span>
            </span>
          </div>
          <p className="text-[13px] text-[#9CA3AF]" data-id="element-66">
            HR & People Operations for growing teams
          </p>
        </div>

        {/* Center — Copyright */}
        <div className="text-sm text-[#9CA3AF]" data-id="element-67">
          &copy; {new Date().getFullYear()} SparkHR
        </div>

        {/* Right — Links */}
        <div className="flex gap-6 text-sm text-[#6B7280]" data-id="element-68">
          <a href="#" className="hover:text-[#111827] transition-colors" data-id="element-69">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-[#111827] transition-colors" data-id="element-70">
            Terms of Service
          </a>
          <a href="#" className="hover:text-[#111827] transition-colors" data-id="element-71">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}